import script from "./CreateSSOConnectionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateSSOConnectionModal.vue?vue&type=script&setup=true&lang=js"

import "./CreateSSOConnectionModal.vue?vue&type=style&index=0&id=41a82b55&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41a82b55"]])

export default __exports__